import React from 'react';
import styled, { css } from 'styled-components';
import { Shapeable } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { EntityCard, EntityCardDefaultProps, EntityCardProps } from '@shapeable/ui';
import { Region } from '@shapeable/kelp-forest-alliance-types';
import { RegionCardMeta } from './region-card-meta';
const cls = classNames('region-card');

// -------- Types -------->

// -------- Props -------->

export type RegionCardProps = Omit<EntityCardProps, 'entity'> & { 
  entity?: Region;
};

export const RegionCardDefaultProps: Omit<RegionCardProps, 'entity'> = {
  ...EntityCardDefaultProps,
};

// -------- Child Component Props -------->

type ContainerProps = {

};

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`

  `,
});

const MetaStyles = breakpoints({
  base: css`
    font-size: 0.8em;
  `,
});


// -------- Components -------->

const My = {
  Container: styled(EntityCard)<ContainerProps>`${ContainerStyles}`,
    Meta: styled(RegionCardMeta)`${MetaStyles}`,
};

export const RegionCard: Shapeable.FC<RegionCardProps> = (props) => {
  const { className, entity, ...cardProps } = props

  return (
    <My.Container 
      {...cardProps}
      className={cls.name(className)}
      labelDeriver={entity => entity?.typeLabel}
      entity={entity}
      meta={
        <My.Meta entity={entity} /> 
      }
    />
  )
};

RegionCard.defaultProps = RegionCardDefaultProps;
RegionCard.cls = cls;